<form [formGroup]="groupForm">
  <mat-form-field style="width: 100%;">
    <mat-label>{{isConvertSubGroup?'Group *':'Groups'}}</mat-label>
    <mat-chip-grid #chipList>
      @for (group of selectedGroups; track group) {
        <mat-chip-row [removable] (removed)="removeGroup(group)">
          {{group}}
          @if (!disabled) {
            <mat-icon matChipRemove svgIcon="cancel"></mat-icon>
          }
        </mat-chip-row>
      }
      @for (subGroup of selectedSubGroups; track subGroup) {
        <mat-chip-row [removable] (removed)="removeSubGroup(subGroup)">
          {{subGroup}}
          @if (!disabled) {
            <mat-icon matChipRemove svgIcon="cancel"></mat-icon>
          }
        </mat-chip-row>
      }
      <input #groupInput formControlName="groupControl" [matAutocomplete]="auto"
        [matChipInputFor]="chipList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
        [matChipInputAddOnBlur]="false" (matChipInputTokenEnd)="addGroup($event)" (click)="openList()">
      </mat-chip-grid>
      <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selectGroup($event)" panelWidth="auto">
        @if (showAutoComplete()) {
          <div>
            @if ((isDivisionTable || isFranchisetable) && (divisionId ? !(divisionGroups.length === 0 && notDivisionGroups.length === 0) : !(franchiseGroups.length === 0 && notFranchiseGroups.length
              === 0))) {
              <div>
                <mat-optgroup [label]="divisionId ? 'Division Groups' : (franchise && franchise.is_series ? 'Series Groups' : 'Feature Groups')">
                  @for (group of filteredGroups$ | async; track $index) {
                    <mat-option [ngStyle]="{'font-weight': group.isSubgroup || isConvertSubGroup?'normal':'bold'}" [value]="group.name">
                      {{group.name}}
                    </mat-option>
                  }
                </mat-optgroup>
              </div>
            }
            <mat-optgroup [label]="'Studio Groups'">
              @for (group of filteredStudioGroups$ | async; track $index) {
                <mat-option [ngStyle]="{'font-weight': group.isSubgroup || isConvertSubGroup?'normal':'bold'}" [value]="group.name">
                  {{group.name}}
                </mat-option>
              }
            </mat-optgroup>
          </div>
        }
      </mat-autocomplete>
    </mat-form-field>
  </form>
